import * as React from 'react'
import { Switch, Route } from 'react-router-dom'
import Error from '@pages/Error'
import PrivateRoute from './PrivateRoute'
import { Inquiry, AdminPanel, Login } from './Loadables'
import { isCoordinatorOnly } from '@utils/roles'
import Dashboard from '@pages/Dashboard'
import Users from '@pages/Users'
import Insurance from '@pages/Insurance'
import Policies from '@pages/Insurance/Policies'
import Policy from '@pages/Insurance/Policy'
import Inquiries from '@pages/Inquiries'
import Notifications from '@pages/Notifications'
import Categories from '@pages/Categories'
import Providers from '@pages/Providers'
import Clients from '@pages/Clients'
import Client from '@pages/Clients/Client'
import RightsTables from '@pages/RightsTables'
import HealthRights from '@pages/HealthRights'
import Drugs from '@pages/Drugs'
import Search from '@pages/Search'
import CollectionTerms from '@pages/HealthRights/CollectionTerms'
import Clinics from '@pages/Clinics'
import Doctors from '@pages/Doctors'
import Synonyms from '@pages/Synonyms'
import InsuranceCalculator from '@pages/InsuranceCalculator'
import SiteContent from '@pages/SiteContent'
import PoliciesTable from '@pages/PoliciesTable'
import Subscriptions from '@pages/Subscriptions'
import Services from '@pages/Services'
import Specs from '@pages/Specs'
import PoliciesPrices from '@pages/Prices'
import Embedded from '@pages/Embedded'
import Logs from '@pages/Logs'
import SurveyResults from '@pages/SurveyResults'
import Statistics from '@pages/Statistics'
import Agent from '@pages/Clients/Agent'
import Tranzila from '@pages/Tranzila'
import TranzilaDocuments from '@pages/Tranzila/Documents'
import Weights from '@pages/Weights'
import InfoMsg from '@pages/InfoMsg'
import Coupons from '@pages/Coupons'
import Log from '@pages/Logs/Log'
import AgentCommissions from '@pages/AgentCommissions'
import MentorsBudget from '@pages/MentorsBudget'
import MentorsMeetings from '@pages/MentorsMeetings'
import CancelSubRequest from '@pages/CancelSubRequests'
import AddClientGroup from '@pages/AddClientGroup'
import GeneralRequest from '@pages/GeneralRequest'
import SmallClientList from '@pages/SmallClientList'
import Whatsapp from '@pages/Whatsapp'
import StartRouter from '@pages/StartRouter'
import UserServiceDashboard from '@pages/UserServiceDashboard'
import PaymentListener from '@pages/PaymentListener'
import SearchStoData from '@pages/SearchStoData'
import ReplacedCards from '@pages/ReplacedCards'
import MediwhoAppLectures from '@pages/MediwhoApp/Lectures'
import MediwhoAppNotifications from '@pages/MediwhoApp/Notifications'
import AppBenefits from '@pages/MediwhoApp/Benefits'
import Flyers from '@pages/Flyers'
export function MainRoutes() {
    return (
        <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/payment-listener" component={PaymentListener} />
            <Route exact path="/payment-listener/:status" component={PaymentListener} />
            <PrivateRoute path="/" component={AdminPanel} />
            <Route component={Error} />
        </Switch>
    )
}

export const AdminRoutes = ({ authStore }) => {
    const { roles } = authStore

    if (roles.includes('outer')) {
        return (
            <Switch>
                <PrivateRoute exact path="/small-client-list" component={SmallClientList} />
                <Route component={Error} />
            </Switch>
        )
    } else if (roles.includes('start_manager') || roles.includes('start')) {
        return (
            <Switch>
                <PrivateRoute path="/start" component={StartRouter} />
                <Route component={Error} />
            </Switch>
        )
    } else if (roles.includes('benefit_partner')) {
        return (
            <Switch>
                <PrivateRoute exact path="/" component={AppBenefits} />
                <PrivateRoute exact path="/mediwho-app/benefits" component={AppBenefits} />
                <Route component={Error} />
            </Switch>
        )
    } else if (roles.includes('digital') && !roles.includes('admin')) {
        return (
            <Switch>
                <PrivateRoute exact path="/" component={MediwhoAppLectures} />
                <PrivateRoute exact path="/mediwho-app/lectures" component={MediwhoAppLectures} />
                <PrivateRoute exact path="/mediwho-app/benefits" component={AppBenefits} />
                <PrivateRoute exact path="/flyers" component={Flyers} />
                <PrivateRoute exact path="/mediwho-app/notifications" component={MediwhoAppNotifications} />
                <Route component={Error} />
            </Switch>
        )
    } else if (isCoordinatorOnly(roles)) {
        return (
            <Switch>
                <PrivateRoute exact path="/" component={MentorsMeetings} />
                <PrivateRoute exact path="/clients" component={Clients} />
                <PrivateRoute exact path="/clients/:id" component={Client} />
                <PrivateRoute exact path="/mentors-meetings" component={MentorsMeetings} />
                <PrivateRoute exact path="/agents/:id" component={Agent} />
                <Route component={Error} />
            </Switch>
        )
    } else
        return (
            <Switch>
                <PrivateRoute exact path="/" component={Dashboard} />
                <PrivateRoute exact path="/users" component={Users} />
                <PrivateRoute exact path="/insurance" component={Insurance} />
                <PrivateRoute exact path="/health-rights" component={HealthRights} />
                <PrivateRoute exact path="/insurance/:id" component={Policies} />
                <PrivateRoute exact path="/insurance/:id/new" component={Policy} />
                <PrivateRoute exact path="/insurance/:id/:policy_id" component={Policy} />
                <PrivateRoute exact path="/insurance-policy" component={PoliciesTable} />
                <PrivateRoute exact path="/inquiries" component={Inquiries} />
                <PrivateRoute exact path="/notifications" component={Notifications} />
                <PrivateRoute exact path="/mediwho-app/lectures" component={MediwhoAppLectures} />
                <PrivateRoute exact path="/mediwho-app/benefits" component={AppBenefits} />
                <PrivateRoute exact path="/flyers" authRoles={['admin', 'digital']} component={Flyers} />
                <PrivateRoute
                    exact
                    path="/mediwho-app/notifications"
                    authRoles={['admin']}
                    component={MediwhoAppNotifications}
                />

                <PrivateRoute exact path="/providers" component={Providers} />
                <PrivateRoute exact path="/clinics" component={Clinics} />
                <PrivateRoute exact path="/categories" component={Categories} />
                <PrivateRoute exact path="/clients" component={Clients} />
                <PrivateRoute exact path="/clients/:id" component={Client} />
                <PrivateRoute exact path="/AgentCommissions" component={AgentCommissions} />
                <PrivateRoute exact path="/mentors-budget" component={MentorsBudget} />
                <PrivateRoute
                    exact
                    path="/mentors-meetings"
                    authRoles={['admin', 'meeting_coordinator','manager']}
                    component={MentorsMeetings}
                />
                <PrivateRoute exact path="/agents/:id" component={Agent} />
                <PrivateRoute exact path="/inquiries/:id" component={Inquiry} />
                <PrivateRoute exact path="/rights-tables" component={RightsTables} />
                <PrivateRoute exact path="/drugs" component={Drugs} />
                <PrivateRoute exact path="/logs" component={Logs} />
                <PrivateRoute
                    exact
                    path="/survey-results"
                    authRoles={['admin', 'moderator', 'developer']}
                    component={SurveyResults}
                />
                <PrivateRoute exact path="/statistics" component={Statistics} />
                <PrivateRoute exact path="/collection-terms/:id" component={CollectionTerms} />
                <PrivateRoute exact path="/doctors" component={Doctors} />
                <PrivateRoute exact path="/insurance-calculator" component={InsuranceCalculator} />
                <PrivateRoute exact path="/insurance-calculator/:id" component={InsuranceCalculator} />
                <PrivateRoute exact path="/synonyms" component={Synonyms} />
                <PrivateRoute exact path="/search" component={Search} />
                <PrivateRoute exact path="/site-content" component={SiteContent} />
                <PrivateRoute exact path="/subscriptions" component={Subscriptions} />
                <PrivateRoute exact path="/services" component={Services} />
                <PrivateRoute exact path="/specs" component={Specs} />
                <PrivateRoute exact path="/policies-prices" component={PoliciesPrices} />
                <PrivateRoute exact path="/coupons" component={Coupons} />
                <PrivateRoute exact path="/embedded-content" component={Embedded} />
                <PrivateRoute exact path="/tranzila" component={Tranzila} />
                {/* Unlike the older Tranzila routes, this one is gated at the route itself and
                    not only by hiding the menu item. The API is still the real boundary. */}
                <PrivateRoute
                    exact
                    path="/tranzila/documents"
                    authRoles={['admin', 'money']}
                    component={TranzilaDocuments}
                />
                <PrivateRoute exact path="/weights" component={Weights} />
                <PrivateRoute exact path="/info-msg" component={InfoMsg} />
                <PrivateRoute exact path="/logs/:id" component={Log} />
                <PrivateRoute exact path="/cancelSubRequests" component={CancelSubRequest} />
                <PrivateRoute exact path="/cancelSubRequests/:id" component={CancelSubRequest} />
                <PrivateRoute exact path="/add-client-group" authRoles={['admin']} component={AddClientGroup} />
                <PrivateRoute exact path="/generalRequest" component={GeneralRequest} />
                <PrivateRoute exact path="/small-client-list" component={SmallClientList} />
                <PrivateRoute exact path="/whatsapp-sessions" component={Whatsapp} />
                <PrivateRoute path="/start" component={StartRouter} />
                <PrivateRoute exact path="/service-dashboard" component={UserServiceDashboard} />
                <PrivateRoute exact path="/sto-search" component={SearchStoData} />
                <PrivateRoute exact path="/replaced-cards" component={ReplacedCards} />
                <Route component={Error} />
            </Switch>
        )
}
